module.exports = __webpack_public_path__ + "static/parade-2020-house06-872c2c1d4aedcfe1e4bce9db8e116e56.jpg";